import { render, staticRenderFns } from "./HomeComp.vue?vue&type=template&id=48b58811&scoped=true"
import script from "./HomeComp.vue?vue&type=script&lang=js"
export * from "./HomeComp.vue?vue&type=script&lang=js"
import style0 from "./HomeComp.vue?vue&type=style&index=0&id=48b58811&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b58811",
  null
  
)

export default component.exports